

// import React, { Component } from "react";
// import Button from "@material-ui/core/Button";
// import Typography from "@material-ui/core/Typography";
// import Grid from "@material-ui/core/Grid";
// import Paper from "@material-ui/core/Paper";
// import Container from "@material-ui/core/Container";
// import Box from "@material-ui/core/Box";
// import Hidden from "@material-ui/core/Hidden";
// import { httpClient } from "../../../appUtility/Api";
// import qs from "qs";

// class DownloadApps extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       showQR: false,
//       selectedPlatform: null,
//       qrData: null,
//       loading: false,
//       error: null
//     };
//   }

//   handleDownloadClick = (platform) => {
//     if (platform === 'android') {
//       alert("Android app is coming soon!");
//       return;
//     }

//     // For iOS
//     const loginOBJ = JSON.parse(localStorage.getItem("login"));
//     const { aid, cid } = loginOBJ;

//     // Check if mobile/tablet (width < 1000px)
//     const isMobileOrTablet = window.matchMedia("(max-width: 1000px)").matches;

//     this.setState({ 
//       loading: true,
//       error: null
//     });

//     httpClient
//       .post(
//         "v2/downloadLink.php",
//         qs.stringify({
//           action: "getLink",
//           "source[appID]": aid,
//           "source[companyID]": cid,
//         })
//       )
//       .then((res) => {
//         if (res.data.success) {
//           this.setState({ 
//             qrData: res.data,
//             selectedPlatform: platform,
//             loading: false 
//           });
          
//           if (isMobileOrTablet) {
//             // Mobile/Tablet - open download link directly
//             window.open(res.data.download, '_blank');
//           } else {
//             // Desktop - show QR code
//             this.setState({ showQR: true });
//           }
//         } else {
//           this.setState({ 
//             error: res.data.message || "Failed to get download link",
//             loading: false 
//           });
//         }
//       })
//       .catch((error) => {
//         console.error("Error fetching download link:", error);
//         this.setState({ 
//           error: "Network error. Please try again.",
//           loading: false 
//         });
//       });
//   };

//   handleOpenDownloadLink = () => {
//     if (this.state.qrData && this.state.qrData.download) {
//       window.open(this.state.qrData.download, '_blank');
//     }
//   };

//   render() {
//     const { showQR, qrData, loading, error } = this.state;
//     const isMobileOrTablet = window.matchMedia("(max-width: 1000px)").matches;

//     return (
//       <Container maxWidth={false} style={{ 
//         padding: '24px 16px', 
//         maxWidth: '100%',
//         minHeight: '100vh'
//       }}>
//         <Typography 
//           variant="h4" 
//           style={{ 
//             fontWeight: 600, 
//             marginBottom: 32,
//             color: '#333',
//             textAlign: 'center'
//           }}
//         >
//           Download Mobile Apps
//         </Typography>
        
//         <Grid container spacing={3} style={{ minHeight: 'calc(100vh - 120px)' }}>
//           {/* iOS Section - Left Side */}
//           <Grid item xs={12} md={6}>
//             <Paper 
//               elevation={3} 
//               style={{ 
//                 borderRadius: 12, 
//                 overflow: 'hidden',
//                 border: '1px solid #e0e0e0',
//                 backgroundColor: '#fff',
//                 height: '100%',
//                 padding: 0
//               }}
//             >
//               <Box style={{ padding: 32 }}>
//                 {/* iOS Header with App Store Icon */}
//                 <Box style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}>
//                   <i 
//                     className="zmdi zmdi-apple" 
//                     style={{ 
//                       fontSize: '36px',
//                       color: '#000',
//                       marginRight: 16
//                     }} 
//                   />
//                   <Box style={{ flex: 1 }}>
//                     <Box style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
//                       <Box style={{ flex: 1 }}>
//                         <Typography 
//                           variant="h5" 
//                           style={{ 
//                             fontWeight: 600,
//                             color: '#333',
//                             lineHeight: 1.2,
//                             marginBottom: 4
//                           }}
//                         >
//                           Download App for Apple/iOS
//                         </Typography>
//                         <Typography 
//                           variant="body1" 
//                           style={{ 
//                             color: '#666',
//                             lineHeight: 1.4
//                           }}
//                         >
//                           Get the app on your iPhone or iPad
//                         </Typography>
//                       </Box>
//                       <Box style={{ 
//                         marginLeft: 16,
//                         display: 'flex',
//                         alignItems: 'flex-start'
//                       }}>
//                         <img 
//                           src="/images/app_store.png" 
//                           alt="App Store"
//                           style={{ 
//                             width: 42, 
//                             height: 42,
//                             objectFit: 'contain'
//                           }}
//                         />
//                       </Box>
//                     </Box>
//                   </Box>
//                 </Box>

//                 {/* Installation Guide - iOS */}
//                 <Box style={{ marginBottom: 32 }}>
//                   <Typography 
//                     variant="h6" 
//                     style={{ 
//                       fontWeight: 600,
//                       marginBottom: 16,
//                       color: '#333',
//                       borderBottom: '1px solid #f0f0f0',
//                       paddingBottom: 8
//                     }}
//                   >
//                     Installation Guide
//                   </Typography>
//                   <Grid container spacing={2}>
//                     {[
//                       { step: 1, desc: "Click the Download button below" },
//                       !isMobileOrTablet && { step: 2, desc: "Scan the QR code generated" },
//                       { step: isMobileOrTablet ? 2 : 3, desc: "Redeem the installation code" },
//                       { step: isMobileOrTablet ? 3 : 4, desc: "Follow installation prompts" },
//                       { step: isMobileOrTablet ? 4 : 5, desc: "Trust developer in Settings (if prompted)" }
//                     ]
//                     .filter(step => step)
//                     .map((item) => (
//                       <Grid item xs={12} sm={6} key={item.step}>
//                         <Box style={{ 
//                           display: 'flex', 
//                           alignItems: 'flex-start',
//                           backgroundColor: '#f9f9f9',
//                           padding: 12,
//                           borderRadius: 6,
//                           marginBottom: 8,
//                           height: '100%'
//                         }}>
//                           <Box style={{ 
//                             width: 24, 
//                             height: 24, 
//                             borderRadius: '50%', 
//                             backgroundColor: '#000',
//                             color: '#fff',
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             marginRight: 12,
//                             flexShrink: 0,
//                             fontSize: '0.875rem',
//                             fontWeight: 600
//                           }}>
//                             {item.step}
//                           </Box>
//                           <Typography variant="body2" style={{ color: '#666' }}>
//                             {item.desc}
//                           </Typography>
//                         </Box>
//                       </Grid>
//                     ))}
//                   </Grid>
//                 </Box>

//                 {/* QR Code Section - Show only when QR is available */}
//                 {showQR && qrData && (
//                   <Box style={{ 
//                     display: 'flex', 
//                     flexDirection: 'column', 
//                     alignItems: 'center',
//                     marginBottom: 32,
//                     padding: '20px 0'
//                   }}>
//                     <Box style={{ 
//                       width: 220, 
//                       height: 220, 
//                       borderRadius: 12,
//                       backgroundColor: '#fff',
//                       border: '2px solid #e0e0e0',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       marginBottom: 24,
//                       padding: 16,
//                       boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
//                     }}>
//                       {qrData.qrcode && (
//                         <img 
//                           src={qrData.qrcode} 
//                           alt="QR Code" 
//                           style={{ 
//                             width: '100%', 
//                             height: '100%',
//                             objectFit: 'contain'
//                           }}
//                         />
//                       )}
//                     </Box>
                    
//                     <Typography 
//                       variant="body1" 
//                       style={{ 
//                         fontWeight: 500,
//                         marginBottom: 16,
//                         color: '#333',
//                         textAlign: 'center'
//                       }}
//                     >
//                       Scan QR code with your phone camera to download
//                     </Typography>
//                   </Box>
//                 )}

//                 {/* Download Button */}
//                 <Box style={{ 
//                   display: 'flex', 
//                   flexDirection: 'column', 
//                   alignItems: 'center',
//                   marginBottom: 32,
//                   padding: '20px 0'
//                 }}>
//                   {loading && (
//                     <Box style={{ 
//                       display: 'flex', 
//                       alignItems: 'center', 
//                       justifyContent: 'center',
//                       marginBottom: 16
//                     }}>
//                       <div className="zmdi zmdi-spinner zmdi-hc-spin" style={{ fontSize: '24px', color: '#666', marginRight: 12 }} />
//                       <Typography variant="body1" color="textSecondary">
//                         Loading...
//                       </Typography>
//                     </Box>
//                   )}
                  
//                   {error && (
//                     <Box style={{ 
//                       backgroundColor: '#ffebee', 
//                       padding: 16, 
//                       borderRadius: 8,
//                       marginBottom: 16,
//                       width: '100%',
//                       textAlign: 'center'
//                     }}>
//                       <Typography variant="body1" color="error">
//                         {error}
//                       </Typography>
//                     </Box>
//                   )}
                  
//                   <Button
//                     variant="contained"
//                     onClick={() => this.handleDownloadClick('ios')}
//                     disabled={loading}
//                     style={{
//                       padding: '14px 40px',
//                       borderRadius: 8,
//                       backgroundColor: '#000',
//                       color: '#fff',
//                       textTransform: 'none',
//                       fontWeight: 600,
//                       fontSize: '1rem',
//                       minWidth: 240,
//                       height: 56
//                     }}
//                   >
//                     <i 
//                       className="zmdi zmdi-apple" 
//                       style={{ 
//                         fontSize: '24px',
//                         marginRight: 12
//                       }} 
//                     />
//                     Download Apple/iOS App
//                   </Button>
//                 </Box>

//                 {/* System Requirements */}
//                 <Box style={{ marginBottom: 24 }}>
//                   <Typography 
//                     variant="h6" 
//                     style={{ 
//                       fontWeight: 600,
//                       marginBottom: 16,
//                       color: '#333',
//                       borderBottom: '1px solid #f0f0f0',
//                       paddingBottom: 8
//                     }}
//                   >
//                     System Requirements
//                   </Typography>
//                   <Grid container spacing={2}>
//                     <Grid item xs={6}>
//                       <Typography variant="body2" style={{ color: '#666', marginBottom: 8 }}>
//                         <Box component="span" style={{ fontWeight: 600 }}>OS Version:</Box> iOS 14+
//                       </Typography>
//                     </Grid>
//                     <Grid item xs={6}>
//                       <Typography variant="body2" style={{ color: '#666', marginBottom: 8 }}>
//                         <Box component="span" style={{ fontWeight: 600 }}>File Size:</Box> 45 MB
//                       </Typography>
//                     </Grid>
//                     <Grid item xs={6}>
//                       <Typography variant="body2" style={{ color: '#666', marginBottom: 8 }}>
//                         <Box component="span" style={{ fontWeight: 600 }}>Storage:</Box> 150 MB
//                       </Typography>
//                     </Grid>
//                   </Grid>
//                 </Box>

//                 {/* How to Check Device Specifications - iOS */}
//                 <Box style={{ marginBottom: 24 }}>
//                   <Typography 
//                     variant="h6" 
//                     style={{ 
//                       fontWeight: 600,
//                       marginBottom: 16,
//                       color: '#333',
//                       borderBottom: '1px solid #f0f0f0',
//                       paddingBottom: 8
//                     }}
//                   >
//                     How to Check Your Device Specifications
//                   </Typography>
//                   <Grid container spacing={2}>
//                     {[
//                       { step: 1, title: "Go to Settings", desc: "Open Settings app on your iPhone/iPad" },
//                       { step: 2, title: "Select General", desc: "Tap on 'General' in the Settings menu" },
//                       { step: 3, title: "Tap About", desc: "Select 'About' to see device information" },
//                       { step: 4, title: "Check Details", desc: "Check iOS version and storage" }
//                     ].map((item) => (
//                       <Grid item xs={12} sm={6} key={item.step}>
//                         <Box style={{ 
//                           display: 'flex', 
//                           alignItems: 'flex-start',
//                           backgroundColor: '#f9f9f9',
//                           padding: 12,
//                           borderRadius: 6,
//                           marginBottom: 8,
//                           height: '100%'
//                         }}>
//                           <Box style={{ 
//                             width: 24, 
//                             height: 24, 
//                             borderRadius: '50%', 
//                             backgroundColor: '#000',
//                             color: '#fff',
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             marginRight: 12,
//                             flexShrink: 0,
//                             fontSize: '0.875rem',
//                             fontWeight: 600
//                           }}>
//                             {item.step}
//                           </Box>
//                           <Box>
//                             <Typography variant="body2" style={{ fontWeight: 600, color: '#333', marginBottom: 2 }}>
//                               {item.title}
//                             </Typography>
//                             <Typography variant="caption" style={{ color: '#666' }}>
//                               {item.desc}
//                             </Typography>
//                           </Box>
//                         </Box>
//                       </Grid>
//                     ))}
//                   </Grid>
//                 </Box>
//               </Box>
//             </Paper>
//           </Grid>

//           {/* Android Section - Right Side - Only Main Title Visible, Everything Else Blurred */}
//           {/* Android Section - Right Side - Only Main Title Visible, Everything Else Blurred */}
// <Grid item xs={12} md={6} style={{ position: 'relative' }}>
//   {/* Coming Soon Overlay - Positioned to not cover the title */}
//   <Box style={{
//     position: 'absolute',
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//     justifyContent: 'center',
//     zIndex: 10,
//     pointerEvents: 'none',
//     borderRadius: 12,
//     marginTop: '80px' // Offset to not cover the title
//   }}>
//     {/* Coming Soon overlay is commented out */}
//   </Box>

//   <Paper 
//     elevation={3} 
//     style={{ 
//       borderRadius: 12, 
//       overflow: 'hidden',
//       border: '1px solid #e0e0f0',
//       backgroundColor: '#fff',
//       height: '100%',
//       padding: 0
//     }}
//   >
//     <Box style={{ padding: 32 }}>
//       {/* Android Header - Main title and all content now visible */}
//       <Box style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}>
//         <i 
//           className="zmdi zmdi-android" 
//           style={{ 
//             fontSize: '36px',
//             color: '#3DDC84',
//             marginRight: 16
//           }} 
//         />
//         <Box style={{ flex: 1 }}>
//           <Box style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
//             <Box style={{ flex: 1 }}>
//               <Typography 
//                 variant="h5" 
//                 style={{ 
//                   fontWeight: 600,
//                   color: '#333',
//                   lineHeight: 1.2,
//                   marginBottom: 4
//                 }}
//               >
//                 Coming Soon for Samsung/Android
//               </Typography>
//               {/* Subtitle is now visible - removed blur */}
//               <Typography 
//                 variant="body1" 
//                 style={{ 
//                   color: '#666',
//                   lineHeight: 1.4
//                 }}
//               >
//                 Get the app on your android device
//               </Typography>
//             </Box>
//             {/* Play Store icon is now visible - removed blur */}
//             <Box style={{ 
//               marginLeft: 16,
//               display: 'flex',
//               alignItems: 'flex-start'
//             }}>
//               <img 
//                 src="/images/google-play.png" 
//                 alt="Google Play Store"
//                 style={{ 
//                   width: 42, 
//                   height: 42,
//                   objectFit: 'contain'
//                 }}
//               />
//             </Box>
//           </Box>
//         </Box>
//       </Box>

//       {/* All content below is now visible - removed blur wrapper */}
//       {/* Installation Guide - Android */}
//       <Box style={{ marginBottom: 32 }}>
//         <Typography 
//           variant="h6" 
//           style={{ 
//             fontWeight: 600,
//             marginBottom: 16,
//             color: '#333',
//             borderBottom: '1px solid #f0f0f0',
//             paddingBottom: 8
//           }}
//         >
//           Installation Guide
//         </Typography>
//         <Grid container spacing={2}>
//           {[
//             { step: 1, desc: "Search for app in Google Play Store" },
//             { step: 2, desc: "Tap 'Install' button when available" },
//             { step: 3, desc: "Accept permissions when prompted" },
//             { step: 4, desc: "Open app after installation completes" }
//           ].map((item) => (
//             <Grid item xs={12} sm={6} key={item.step}>
//               <Box style={{ 
//                 display: 'flex', 
//                 alignItems: 'flex-start',
//                 backgroundColor: '#f9f9f9',
//                 padding: 12,
//                 borderRadius: 6,
//                 marginBottom: 8,
//                 height: '100%'
//               }}>
//                 <Box style={{ 
//                   width: 24, 
//                   height: 24, 
//                   borderRadius: '50%', 
//                   backgroundColor: '#3DDC84',
//                   color: '#fff',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   marginRight: 12,
//                   flexShrink: 0,
//                   fontSize: '0.875rem',
//                   fontWeight: 600
//                 }}>
//                   {item.step}
//                 </Box>
//                 <Typography variant="body2" style={{ color: '#666' }}>
//                   {item.desc}
//                 </Typography>
//               </Box>
//             </Grid>
//           ))}
//         </Grid>
//       </Box>

//       {/* Android Download Button */}
//       <Box style={{ 
//         display: 'flex', 
//         flexDirection: 'column', 
//         alignItems: 'center',
//         marginBottom: 32,
//         padding: '20px 0'
//       }}>
//         <Button
//           variant="contained"
//           onClick={() => {}}
//           disabled
//           style={{
//             padding: '14px 40px',
//             borderRadius: 8,
//             backgroundColor: '#3DDC84',
//             color: '#000',
//             textTransform: 'none',
//             fontWeight: 600,
//             fontSize: '1rem',
//             minWidth: 240,
//             height: 56,
//             cursor: 'not-allowed',
//             opacity: 0.8
//           }}
//         >
//           <i 
//             className="zmdi zmdi-android" 
//             style={{ 
//               fontSize: '24px',
//               marginRight: 12
//             }} 
//           />
//           Android App Coming Soon
//         </Button>
        
//         <Typography 
//           variant="body2" 
//           style={{ 
//             marginTop: 12,
//             color: '#666',
//             textAlign: 'center'
//           }}
//         >
//           Currently under review in Google Playstore
//         </Typography>
//       </Box>

//       {/* System Requirements - Android */}
//       <Box style={{ marginBottom: 24 }}>
//         <Typography 
//           variant="h6" 
//           style={{ 
//             fontWeight: 600,
//             marginBottom: 16,
//             color: '#333',
//             borderBottom: '1px solid #f0f0f0',
//             paddingBottom: 8
//           }}
//         >
//           System Requirements
//         </Typography>
//         <Grid container spacing={2}>
//           <Grid item xs={6}>
//             <Typography variant="body2" style={{ color: '#666', marginBottom: 8 }}>
//               <Box component="span" style={{ fontWeight: 600 }}>OS Version:</Box> Android 8.0+
//             </Typography>
//           </Grid>
//           <Grid item xs={6}>
//             <Typography variant="body2" style={{ color: '#666', marginBottom: 8 }}>
//               <Box component="span" style={{ fontWeight: 600 }}>File Size:</Box> ~50 MB
//             </Typography>
//           </Grid>
//           <Grid item xs={6}>
//             <Typography variant="body2" style={{ color: '#666', marginBottom: 8 }}>
//               <Box component="span" style={{ fontWeight: 600 }}>RAM:</Box> 2 GB minimum
//             </Typography>
//           </Grid>
//           <Grid item xs={6}>
//             <Typography variant="body2" style={{ color: '#666', marginBottom: 8 }}>
//               <Box component="span" style={{ fontWeight: 600 }}>Storage:</Box> 150 MB
//             </Typography>
//           </Grid>
//         </Grid>
//       </Box>

//       {/* How to Check Device Specifications - Android */}
//       <Box style={{ marginBottom: 24 }}>
//         <Typography 
//           variant="h6" 
//           style={{ 
//             fontWeight: 600,
//             marginBottom: 16,
//             color: '#333',
//             borderBottom: '1px solid #f0f0f0',
//             paddingBottom: 8
//           }}
//         >
//           How to Check Your Device Specifications
//         </Typography>
//         <Grid container spacing={2}>
//           {[
//             { step: 1, title: "Go to Settings", desc: "Open Settings app on your Android device" },
//             { step: 2, title: "Select About Phone", desc: "Scroll down and tap 'About Phone'" },
//             { step: 3, title: "Check Details", desc: "View Android version, RAM, and storage" },
//             { step: 4, title: "Software Info", desc: "Check for 'Software Information' section" }
//           ].map((item) => (
//             <Grid item xs={12} sm={6} key={item.step}>
//               <Box style={{ 
//                 display: 'flex', 
//                 alignItems: 'flex-start',
//                 backgroundColor: '#f9f9f9',
//                 padding: 12,
//                 borderRadius: 6,
//                 marginBottom: 8,
//                 height: '100%'
//               }}>
//                 <Box style={{ 
//                   width: 24, 
//                   height: 24, 
//                   borderRadius: '50%', 
//                   backgroundColor: '#3DDC84',
//                   color: '#fff',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   marginRight: 12,
//                   flexShrink: 0,
//                   fontSize: '0.875rem',
//                   fontWeight: 600
//                 }}>
//                   {item.step}
//                 </Box>
//                 <Box>
//                   <Typography variant="body2" style={{ fontWeight: 600, color: '#333', marginBottom: 2 }}>
//                     {item.title}
//                   </Typography>
//                   <Typography variant="caption" style={{ color: '#666' }}>
//                     {item.desc}
//                   </Typography>
//                 </Box>
//               </Box>
//             </Grid>
//           ))}
//         </Grid>
//       </Box>
//     </Box>
//   </Paper>
// </Grid>
//         </Grid>
//       </Container>
//     );
//   }
// }

// export default DownloadApps;


// *************************************************************************************************************************
// import React, { Component } from "react";
// import Button from "@material-ui/core/Button";
// import Typography from "@material-ui/core/Typography";
// import Grid from "@material-ui/core/Grid";
// import Paper from "@material-ui/core/Paper";
// import Container from "@material-ui/core/Container";
// import Box from "@material-ui/core/Box";
// import Hidden from "@material-ui/core/Hidden";
// import { httpClient } from "../../../appUtility/Api";
// import qs from "qs";

// class DownloadApps extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       showQR: false,
//       showAndroidQR: false, // New state for Android QR
//       selectedPlatform: null,
//       qrData: null,
//       androidQrData: null, // New state for Android QR data
//       loading: false,
//       androidLoading: false, // New state for Android loading
//       error: null,
//       androidError: null // New state for Android error
//     };
//   }

//   handleDownloadClick = (platform) => {
//     if (platform === 'android') {
//       this.handleAndroidDownloadClick();
//       return;
//     }

//     // For iOS
//     const loginOBJ = JSON.parse(localStorage.getItem("login"));
//     const { aid, cid } = loginOBJ;

//     // Check if mobile/tablet (width < 1000px)
//     const isMobileOrTablet = window.matchMedia("(max-width: 1000px)").matches;

//     this.setState({ 
//       loading: true,
//       error: null
//     });

//     httpClient
//       .post(
//         "v2/downloadLink.php",
//         qs.stringify({
//           action: "getLink",
//           "source[appID]": aid,
//           "source[companyID]": cid,
//         })
//       )
//       .then((res) => {
//         if (res.data.success) {
//           this.setState({ 
//             qrData: res.data,
//             selectedPlatform: platform,
//             loading: false 
//           });
          
//           if (isMobileOrTablet) {
//             // Mobile/Tablet - open download link directly
//             window.open(res.data.download, '_blank');
//           } else {
//             // Desktop - show QR code
//             this.setState({ showQR: true });
//           }
//         } else {
//           this.setState({ 
//             error: res.data.message || "Failed to get download link",
//             loading: false 
//           });
//         }
//       })
//       .catch((error) => {
//         console.error("Error fetching download link:", error);
//         this.setState({ 
//           error: "Network error. Please try again.",
//           loading: false 
//         });
//       });
//   };

//   handleAndroidDownloadClick = () => {
//     const loginOBJ = JSON.parse(localStorage.getItem("login"));
//     const { aid, cid } = loginOBJ;

//     // Check if mobile/tablet (width < 1000px)
//     const isMobileOrTablet = window.matchMedia("(max-width: 1000px)").matches;

//     this.setState({ 
//       androidLoading: true,
//       androidError: null
//     });

//     httpClient
//       .post(
//         "v2/downloadLink.php",
//         qs.stringify({
//           action: "getLink",
//           "source[appID]": aid,
//           "source[companyID]": cid,
//         })
//       )
//       .then((res) => {
//         if (res.data.success) {
//           this.setState({ 
//             androidQrData: res.data,
//             androidLoading: false 
//           });
          
//           if (isMobileOrTablet) {
//             // Mobile/Tablet - open download link directly
//             window.open(res.data.androidDownload, '_blank');
//           } else {
//             // Desktop - show QR code
//             this.setState({ showAndroidQR: true });
//           }
//         } else {
//           this.setState({ 
//             androidError: res.data.message || "Failed to get download link",
//             androidLoading: false 
//           });
//         }
//       })
//       .catch((error) => {
//         console.error("Error fetching Android download link:", error);
//         this.setState({ 
//           androidError: "Network error. Please try again.",
//           androidLoading: false 
//         });
//       });
//   };

//   handleOpenDownloadLink = () => {
//     if (this.state.qrData && this.state.qrData.download) {
//       window.open(this.state.qrData.download, '_blank');
//     }
//   };

//   handleOpenAndroidDownloadLink = () => {
//     if (this.state.androidQrData && this.state.androidQrData.androidDownload) {
//       window.open(this.state.androidQrData.androidDownload, '_blank');
//     }
//   };

//   render() {
//     const { showQR, showAndroidQR, qrData, androidQrData, loading, androidLoading, error, androidError } = this.state;
//     const isMobileOrTablet = window.matchMedia("(max-width: 1000px)").matches;

//     return (
//       <Container maxWidth={false} style={{ 
//         padding: '24px 16px', 
//         maxWidth: '100%',
//         minHeight: '100vh'
//       }}>
//         <Typography 
//           variant="h4" 
//           style={{ 
//             fontWeight: 600, 
//             marginBottom: 32,
//             color: '#333',
//             textAlign: 'center'
//           }}
//         >
//           Download Mobile Apps
//         </Typography>
        
//         <Grid container spacing={3} style={{ minHeight: 'calc(100vh - 120px)' }}>
//           {/* iOS Section - Left Side */}
//           <Grid item xs={12} md={6}>
//             <Paper 
//               elevation={3} 
//               style={{ 
//                 borderRadius: 12, 
//                 overflow: 'hidden',
//                 border: '1px solid #e0e0e0',
//                 backgroundColor: '#fff',
//                 height: '100%',
//                 padding: 0
//               }}
//             >
//               <Box style={{ padding: 32 }}>
//                 {/* iOS Header with App Store Icon */}
//                 <Box style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}>
//                   <i 
//                     className="zmdi zmdi-apple" 
//                     style={{ 
//                       fontSize: '36px',
//                       color: '#000',
//                       marginRight: 16
//                     }} 
//                   />
//                   <Box style={{ flex: 1 }}>
//                     <Box style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
//                       <Box style={{ flex: 1 }}>
//                         <Typography 
//                           variant="h5" 
//                           style={{ 
//                             fontWeight: 600,
//                             color: '#333',
//                             lineHeight: 1.2,
//                             marginBottom: 4
//                           }}
//                         >
//                           Download App for Apple/iOS
//                         </Typography>
//                         <Typography 
//                           variant="body1" 
//                           style={{ 
//                             color: '#666',
//                             lineHeight: 1.4
//                           }}
//                         >
//                           Get the app on your iPhone or iPad
//                         </Typography>
//                       </Box>
//                       <Box style={{ 
//                         marginLeft: 16,
//                         display: 'flex',
//                         alignItems: 'flex-start'
//                       }}>
//                         <img 
//                           src="/images/app_store.png" 
//                           alt="App Store"
//                           style={{ 
//                             width: 42, 
//                             height: 42,
//                             objectFit: 'contain'
//                           }}
//                         />
//                       </Box>
//                     </Box>
//                   </Box>
//                 </Box>

//                 {/* Installation Guide - iOS */}
//                 <Box style={{ marginBottom: 32 }}>
//                   <Typography 
//                     variant="h6" 
//                     style={{ 
//                       fontWeight: 600,
//                       marginBottom: 16,
//                       color: '#333',
//                       borderBottom: '1px solid #f0f0f0',
//                       paddingBottom: 8
//                     }}
//                   >
//                     Installation Guide
//                   </Typography>
//                   <Grid container spacing={2}>
//                     {[
//                       { step: 1, desc: "Click the Download button below" },
//                       !isMobileOrTablet && { step: 2, desc: "Scan the QR code generated" },
//                       { step: isMobileOrTablet ? 2 : 3, desc: "Redeem the installation code" },
//                       { step: isMobileOrTablet ? 3 : 4, desc: "Follow installation prompts" },
//                       { step: isMobileOrTablet ? 4 : 5, desc: "Trust developer in Settings (if prompted)" }
//                     ]
//                     .filter(step => step)
//                     .map((item) => (
//                       <Grid item xs={12} sm={6} key={item.step}>
//                         <Box style={{ 
//                           display: 'flex', 
//                           alignItems: 'flex-start',
//                           backgroundColor: '#f9f9f9',
//                           padding: 12,
//                           borderRadius: 6,
//                           marginBottom: 8,
//                           height: '100%'
//                         }}>
//                           <Box style={{ 
//                             width: 24, 
//                             height: 24, 
//                             borderRadius: '50%', 
//                             backgroundColor: '#000',
//                             color: '#fff',
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             marginRight: 12,
//                             flexShrink: 0,
//                             fontSize: '0.875rem',
//                             fontWeight: 600
//                           }}>
//                             {item.step}
//                           </Box>
//                           <Typography variant="body2" style={{ color: '#666' }}>
//                             {item.desc}
//                           </Typography>
//                         </Box>
//                       </Grid>
//                     ))}
//                   </Grid>
//                 </Box>

//                 {/* QR Code Section - iOS */}
//                 {showQR && qrData && (
//                   <Box style={{ 
//                     display: 'flex', 
//                     flexDirection: 'column', 
//                     alignItems: 'center',
//                     marginBottom: 32,
//                     padding: '20px 0'
//                   }}>
//                     <Box style={{ 
//                       width: 220, 
//                       height: 220, 
//                       borderRadius: 12,
//                       backgroundColor: '#fff',
//                       border: '2px solid #e0e0e0',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       marginBottom: 24,
//                       padding: 16,
//                       boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
//                     }}>
//                       {qrData.qrcode && (
//                         <img 
//                           src={qrData.qrcode} 
//                           alt="QR Code" 
//                           style={{ 
//                             width: '100%', 
//                             height: '100%',
//                             objectFit: 'contain'
//                           }}
//                         />
//                       )}
//                     </Box>
                    
//                     <Typography 
//                       variant="body1" 
//                       style={{ 
//                         fontWeight: 500,
//                         marginBottom: 16,
//                         color: '#333',
//                         textAlign: 'center'
//                       }}
//                     >
//                       Scan QR code with your phone camera to download
//                     </Typography>
//                   </Box>
//                 )}

//                 {/* Download Button - iOS */}
//                 <Box style={{ 
//                   display: 'flex', 
//                   flexDirection: 'column', 
//                   alignItems: 'center',
//                   marginBottom: 32,
//                   padding: '20px 0'
//                 }}>
//                   {loading && (
//                     <Box style={{ 
//                       display: 'flex', 
//                       alignItems: 'center', 
//                       justifyContent: 'center',
//                       marginBottom: 16
//                     }}>
//                       <div className="zmdi zmdi-spinner zmdi-hc-spin" style={{ fontSize: '24px', color: '#666', marginRight: 12 }} />
//                       <Typography variant="body1" color="textSecondary">
//                         Loading...
//                       </Typography>
//                     </Box>
//                   )}
                  
//                   {error && (
//                     <Box style={{ 
//                       backgroundColor: '#ffebee', 
//                       padding: 16, 
//                       borderRadius: 8,
//                       marginBottom: 16,
//                       width: '100%',
//                       textAlign: 'center'
//                     }}>
//                       <Typography variant="body1" color="error">
//                         {error}
//                       </Typography>
//                     </Box>
//                   )}
                  
//                   <Button
//                     variant="contained"
//                     onClick={() => this.handleDownloadClick('ios')}
//                     disabled={loading}
//                     style={{
//                       padding: '14px 40px',
//                       borderRadius: 8,
//                       backgroundColor: '#000',
//                       color: '#fff',
//                       textTransform: 'none',
//                       fontWeight: 600,
//                       fontSize: '1rem',
//                       minWidth: 240,
//                       height: 56
//                     }}
//                   >
//                     <i 
//                       className="zmdi zmdi-apple" 
//                       style={{ 
//                         fontSize: '24px',
//                         marginRight: 12
//                       }} 
//                     />
//                     Download Apple/iOS App
//                   </Button>
//                 </Box>

//                 {/* System Requirements - iOS */}
//                 <Box style={{ marginBottom: 24 }}>
//                   <Typography 
//                     variant="h6" 
//                     style={{ 
//                       fontWeight: 600,
//                       marginBottom: 16,
//                       color: '#333',
//                       borderBottom: '1px solid #f0f0f0',
//                       paddingBottom: 8
//                     }}
//                   >
//                     System Requirements
//                   </Typography>
//                   <Grid container spacing={2}>
//                     <Grid item xs={6}>
//                       <Typography variant="body2" style={{ color: '#666', marginBottom: 8 }}>
//                         <Box component="span" style={{ fontWeight: 600 }}>OS Version:</Box> iOS 14+
//                       </Typography>
//                     </Grid>
//                     <Grid item xs={6}>
//                       <Typography variant="body2" style={{ color: '#666', marginBottom: 8 }}>
//                         <Box component="span" style={{ fontWeight: 600 }}>File Size:</Box> 45 MB
//                       </Typography>
//                     </Grid>
//                     <Grid item xs={6}>
//                       <Typography variant="body2" style={{ color: '#666', marginBottom: 8 }}>
//                         <Box component="span" style={{ fontWeight: 600 }}>Storage:</Box> 150 MB
//                       </Typography>
//                     </Grid>
//                   </Grid>
//                 </Box>

//                 {/* How to Check Device Specifications - iOS */}
//                 <Box style={{ marginBottom: 24 }}>
//                   <Typography 
//                     variant="h6" 
//                     style={{ 
//                       fontWeight: 600,
//                       marginBottom: 16,
//                       color: '#333',
//                       borderBottom: '1px solid #f0f0f0',
//                       paddingBottom: 8
//                     }}
//                   >
//                     How to Check Your Device Specifications
//                   </Typography>
//                   <Grid container spacing={2}>
//                     {[
//                       { step: 1, title: "Go to Settings", desc: "Open Settings app on your iPhone/iPad" },
//                       { step: 2, title: "Select General", desc: "Tap on 'General' in the Settings menu" },
//                       { step: 3, title: "Tap About", desc: "Select 'About' to see device information" },
//                       { step: 4, title: "Check Details", desc: "Check iOS version and storage" }
//                     ].map((item) => (
//                       <Grid item xs={12} sm={6} key={item.step}>
//                         <Box style={{ 
//                           display: 'flex', 
//                           alignItems: 'flex-start',
//                           backgroundColor: '#f9f9f9',
//                           padding: 12,
//                           borderRadius: 6,
//                           marginBottom: 8,
//                           height: '100%'
//                         }}>
//                           <Box style={{ 
//                             width: 24, 
//                             height: 24, 
//                             borderRadius: '50%', 
//                             backgroundColor: '#000',
//                             color: '#fff',
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             marginRight: 12,
//                             flexShrink: 0,
//                             fontSize: '0.875rem',
//                             fontWeight: 600
//                           }}>
//                             {item.step}
//                           </Box>
//                           <Box>
//                             <Typography variant="body2" style={{ fontWeight: 600, color: '#333', marginBottom: 2 }}>
//                               {item.title}
//                             </Typography>
//                             <Typography variant="caption" style={{ color: '#666' }}>
//                               {item.desc}
//                             </Typography>
//                           </Box>
//                         </Box>
//                       </Grid>
//                     ))}
//                   </Grid>
//                 </Box>
//               </Box>
//             </Paper>
//           </Grid>

//           {/* Android Section - Right Side */}
//           <Grid item xs={12} md={6} style={{ position: 'relative' }}>
//             <Paper 
//               elevation={3} 
//               style={{ 
//                 borderRadius: 12, 
//                 overflow: 'hidden',
//                 border: '1px solid #e0e0f0',
//                 backgroundColor: '#fff',
//                 height: '100%',
//                 padding: 0
//               }}
//             >
//               <Box style={{ padding: 32 }}>
//                 {/* Android Header */}
//                 <Box style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}>
//                   <i 
//                     className="zmdi zmdi-android" 
//                     style={{ 
//                       fontSize: '36px',
//                       color: '#3DDC84',
//                       marginRight: 16
//                     }} 
//                   />
//                   <Box style={{ flex: 1 }}>
//                     <Box style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
//                       <Box style={{ flex: 1 }}>
//                         <Typography 
//                           variant="h5" 
//                           style={{ 
//                             fontWeight: 600,
//                             color: '#333',
//                             lineHeight: 1.2,
//                             marginBottom: 4
//                           }}
//                         >
//                           Download App for Samsung/Android
//                         </Typography>
//                         <Typography 
//                           variant="body1" 
//                           style={{ 
//                             color: '#666',
//                             lineHeight: 1.4
//                           }}
//                         >
//                           Get the app on your android device
//                         </Typography>
//                       </Box>
//                       <Box style={{ 
//                         marginLeft: 16,
//                         display: 'flex',
//                         alignItems: 'flex-start'
//                       }}>
//                         <img 
//                           src="/images/google-play.png" 
//                           alt="Google Play Store"
//                           style={{ 
//                             width: 42, 
//                             height: 42,
//                             objectFit: 'contain'
//                           }}
//                         />
//                       </Box>
//                     </Box>
//                   </Box>
//                 </Box>

//                 {/* Installation Guide - Android */}
//                 <Box style={{ marginBottom: 32 }}>
//                   <Typography 
//                     variant="h6" 
//                     style={{ 
//                       fontWeight: 600,
//                       marginBottom: 16,
//                       color: '#333',
//                       borderBottom: '1px solid #f0f0f0',
//                       paddingBottom: 8
//                     }}
//                   >
//                     Installation Guide
//                   </Typography>
//                   <Grid container spacing={2}>
//                     {[
//                       { step: 1, desc: "Click the Download button below" },
//                       !isMobileOrTablet && { step: 2, desc: "Scan the QR code generated" },
//                       { step: isMobileOrTablet ? 2 : 3, desc: "Tap 'Install' button" },
//                       { step: isMobileOrTablet ? 3 : 4, desc: "Follow installation prompts" },
//                       { step: isMobileOrTablet ? 4 : 5, desc: "Accept permissions (if prompted)" }
//                     ]
//                     .filter(step => step)
//                     .map((item) => (
//                       <Grid item xs={12} sm={6} key={item.step}>
//                         <Box style={{ 
//                           display: 'flex', 
//                           alignItems: 'flex-start',
//                           backgroundColor: '#f9f9f9',
//                           padding: 12,
//                           borderRadius: 6,
//                           marginBottom: 8,
//                           height: '100%'
//                         }}>
//                           <Box style={{ 
//                             width: 24, 
//                             height: 24, 
//                             borderRadius: '50%', 
//                             backgroundColor: '#3DDC84',
//                             color: '#fff',
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             marginRight: 12,
//                             flexShrink: 0,
//                             fontSize: '0.875rem',
//                             fontWeight: 600
//                           }}>
//                             {item.step}
//                           </Box>
//                           <Typography variant="body2" style={{ color: '#666' }}>
//                             {item.desc}
//                           </Typography>
//                         </Box>
//                       </Grid>
//                     ))}
//                   </Grid>
//                 </Box>

//                 {/* QR Code Section - Android */}
//                 {showAndroidQR && androidQrData && (
//                   <Box style={{ 
//                     display: 'flex', 
//                     flexDirection: 'column', 
//                     alignItems: 'center',
//                     marginBottom: 32,
//                     padding: '20px 0'
//                   }}>
//                     <Box style={{ 
//                       width: 220, 
//                       height: 220, 
//                       borderRadius: 12,
//                       backgroundColor: '#fff',
//                       border: '2px solid #e0e0e0',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       marginBottom: 24,
//                       padding: 16,
//                       boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
//                     }}>
//                       {androidQrData.androidQrcode && (
//                         <img 
//                           src={androidQrData.androidQrcode} 
//                           alt="Android QR Code" 
//                           style={{ 
//                             width: '100%', 
//                             height: '100%',
//                             objectFit: 'contain'
//                           }}
//                         />
//                       )}
//                     </Box>
                    
//                     <Typography 
//                       variant="body1" 
//                       style={{ 
//                         fontWeight: 500,
//                         marginBottom: 16,
//                         color: '#333',
//                         textAlign: 'center'
//                       }}
//                     >
//                       Scan QR code with your phone camera to download
//                     </Typography>
//                   </Box>
//                 )}

//                 {/* Android Download Button */}
//               {/* Android Download Button */}
// <Box style={{ 
//   display: 'flex', 
//   flexDirection: 'column', 
//   alignItems: 'center',
//   marginBottom: 32,
//   padding: '20px 0'
// }}>
//   {androidLoading && (
//     <Box style={{ 
//       display: 'flex', 
//       alignItems: 'center', 
//       justifyContent: 'center',
//       marginBottom: 16
//     }}>
//       <div className="zmdi zmdi-spinner zmdi-hc-spin" style={{ fontSize: '24px', color: '#666', marginRight: 12 }} />
//       <Typography variant="body1" color="textSecondary">
//         Loading...
//       </Typography>
//     </Box>
//   )}
  
//   {androidError && (
//     <Box style={{ 
//       backgroundColor: '#ffebee', 
//       padding: 16, 
//       borderRadius: 8,
//       marginBottom: 16,
//       width: '100%',
//       textAlign: 'center'
//     }}>
//       <Typography variant="body1" color="error">
//         {androidError}
//       </Typography>
//     </Box>
//   )}
  
//   <Button
//     variant="contained"
//     onClick={() => this.handleDownloadClick('android')}
//     disabled={androidLoading}
//     style={{
//       padding: '14px 24px', // Reduced horizontal padding
//       borderRadius: 8,
//       backgroundColor: '#3DDC84',
//       color: '#000',
//       textTransform: 'none',
//       fontWeight: 600,
//       fontSize: '1rem',
//       minWidth: {
//         xs: '100%', // Full width on extra small screens
//         sm: 280,    // Fixed width on small screens and up
//         md: 280     // Fixed width on medium screens and up
//       },
//       maxWidth: '100%', // Prevent overflow
//       height: 56,
//       whiteSpace: 'normal', // Allow text to wrap
//       lineHeight: 1.2,      // Better line height for wrapped text
//       textAlign: 'center'
//     }}
//   >
//     <i 
//       className="zmdi zmdi-android" 
//       style={{ 
//         fontSize: '24px',
//         marginRight: 8, // Reduced margin
//         flexShrink: 0   // Prevent icon from shrinking
//       }} 
//     />
//     <Box component="span" style={{ 
//       display: 'inline-block',
//       wordBreak: 'break-word' // Allow word breaking if needed
//     }}>
//       Download Samsung/Android App
//     </Box>
//   </Button>
  
//   {/* <Typography 
//     variant="body2" 
//     style={{ 
//       marginTop: 12,
//       color: '#666',
//       textAlign: 'center'
//     }}
//   >
//     Currently under review in Google Playstore
//   </Typography> */}
// </Box>

//                 {/* System Requirements - Android */}
//                 <Box style={{ marginBottom: 24 }}>
//                   <Typography 
//                     variant="h6" 
//                     style={{ 
//                       fontWeight: 600,
//                       marginBottom: 16,
//                       color: '#333',
//                       borderBottom: '1px solid #f0f0f0',
//                       paddingBottom: 8
//                     }}
//                   >
//                     System Requirements
//                   </Typography>
//                   <Grid container spacing={2}>
//                     <Grid item xs={6}>
//                       <Typography variant="body2" style={{ color: '#666', marginBottom: 8 }}>
//                         <Box component="span" style={{ fontWeight: 600 }}>OS Version:</Box> Android 7.0+
//                       </Typography>
//                     </Grid>
//                     <Grid item xs={6}>
//                       <Typography variant="body2" style={{ color: '#666', marginBottom: 8 }}>
//                         <Box component="span" style={{ fontWeight: 600 }}>File Size:</Box>~ 35 MB
//                       </Typography>
//                     </Grid>
//                     <Grid item xs={6}>
//                       <Typography variant="body2" style={{ color: '#666', marginBottom: 8 }}>
//                         <Box component="span" style={{ fontWeight: 600 }}>RAM:</Box> 2 GB minimum
//                       </Typography>
//                     </Grid>
//                     <Grid item xs={6}>
//                       <Typography variant="body2" style={{ color: '#666', marginBottom: 8 }}>
//                         <Box component="span" style={{ fontWeight: 600 }}>Storage:</Box> 150 MB
//                       </Typography>
//                     </Grid>
//                   </Grid>
//                 </Box>

//                 {/* How to Check Device Specifications - Android */}
//                 <Box style={{ marginBottom: 24 }}>
//                   <Typography 
//                     variant="h6" 
//                     style={{ 
//                       fontWeight: 600,
//                       marginBottom: 16,
//                       color: '#333',
//                       borderBottom: '1px solid #f0f0f0',
//                       paddingBottom: 8
//                     }}
//                   >
//                     How to Check Your Device Specifications
//                   </Typography>
//                   <Grid container spacing={2}>
//                     {[
//                       { step: 1, title: "Go to Settings", desc: "Open Settings app on your Android device" },
//                       { step: 2, title: "Select About Phone", desc: "Scroll down and tap 'About Phone'" },
//                       { step: 3, title: "Check Details", desc: "View Android version, RAM, and storage" },
//                       // { step: 4, title: "Software Info", desc: "Check for 'Software Information' section" }
//                     ].map((item) => (
//                       <Grid item xs={12} sm={6} key={item.step}>
//                         <Box style={{ 
//                           display: 'flex', 
//                           alignItems: 'flex-start',
//                           backgroundColor: '#f9f9f9',
//                           padding: 12,
//                           borderRadius: 6,
//                           marginBottom: 8,
//                           height: '100%'
//                         }}>
//                           <Box style={{ 
//                             width: 24, 
//                             height: 24, 
//                             borderRadius: '50%', 
//                             backgroundColor: '#3DDC84',
//                             color: '#fff',
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             marginRight: 12,
//                             flexShrink: 0,
//                             fontSize: '0.875rem',
//                             fontWeight: 600
//                           }}>
//                             {item.step}
//                           </Box>
//                           <Box>
//                             <Typography variant="body2" style={{ fontWeight: 600, color: '#333', marginBottom: 2 }}>
//                               {item.title}
//                             </Typography>
//                             <Typography variant="caption" style={{ color: '#666' }}>
//                               {item.desc}
//                             </Typography>
//                           </Box>
//                         </Box>
//                       </Grid>
//                     ))}
//                   </Grid>
//                 </Box>
//               </Box>
//             </Paper>
//           </Grid>
//         </Grid>
//       </Container>
//     );
//   }
// }

// export default DownloadApps;


// *********************************************************************************************************

// import React, { Component } from "react";
// import Button from "@material-ui/core/Button";
// import Typography from "@material-ui/core/Typography";
// import Grid from "@material-ui/core/Grid";
// import Paper from "@material-ui/core/Paper";
// import Container from "@material-ui/core/Container";
// import Box from "@material-ui/core/Box";
// import Hidden from "@material-ui/core/Hidden";
// import { httpClient } from "../../../appUtility/Api";
// import qs from "qs";

// class DownloadApps extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       showQR: false,
//       showAndroidQR: false,
//       selectedPlatform: null,
//       qrData: null,
//       androidQrData: null,
//       loading: false,
//       androidLoading: false,
//       error: null,
//       androidError: null
//     };
//   }

//   /* ---------- SAFE NAVIGATION (ONLY FOR IOS SAFARI) ---------- */
//   safeNavigation = (url, existingTab) => {
//     if (existingTab && !existingTab.closed) {
//       existingTab.location.href = url;
//       return;
//     }

//     var tab = window.open("", "_blank");

//     if (tab) {
//       tab.location.href = url;
//     } else {
//       window.location.href = url;
//     }
//   };

//   /* ---------- IOS DOWNLOAD (WITH SAFARI FIX) ---------- */
//   handleDownloadClick = (platform) => {
//     if (platform === 'android') {
//       this.handleAndroidDownloadClick();
//       return;
//     }

//     const loginOBJ = JSON.parse(localStorage.getItem("login"));
//     const { aid, cid } = loginOBJ;

//     const isMobileOrTablet = window.matchMedia("(max-width: 1000px)").matches;
//     const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

//     // Only pre-open tab for iOS devices
//     var tab = (isMobileOrTablet && isIOS) ? window.open("", "_blank") : null;

//     this.setState({ 
//       loading: true,
//       error: null
//     });

//     httpClient
//       .post(
//         "v2/downloadLink.php",
//         qs.stringify({
//           action: "getLink",
//           "source[appID]": aid,
//           "source[companyID]": cid,
//         })
//       )
//       .then((res) => {
//         if (res.data.success) {
//           this.setState({ 
//             qrData: res.data,
//             selectedPlatform: platform,
//             loading: false 
//           });
          
//           if (isMobileOrTablet) {
//             if (isIOS) {
//               // iOS: Use safe navigation with pre-opened tab
//               this.safeNavigation(res.data.download, tab);
//             } else {
//               // Android mobile: Use regular window.open
//               window.open(res.data.download, '_blank');
//             }
//           } else {
//             this.setState({ showQR: true });
//           }
//         } else {
//           if (tab) tab.close();
//           this.setState({ 
//             error: res.data.message || "Failed to get download link",
//             loading: false 
//           });
//         }
//       })
//       .catch((error) => {
//         if (tab) tab.close();
//         console.error("Error fetching download link:", error);
//         this.setState({ 
//           error: "Network error. Please try again.",
//           loading: false 
//         });
//       });
//   };

//   /* ---------- ANDROID DOWNLOAD (UNCHANGED - NORMAL REDIRECT) ---------- */
//   handleAndroidDownloadClick = () => {
//     const loginOBJ = JSON.parse(localStorage.getItem("login"));
//     const { aid, cid } = loginOBJ;

//     const isMobileOrTablet = window.matchMedia("(max-width: 1000px)").matches;

//     this.setState({ 
//       androidLoading: true,
//       androidError: null
//     });

//     httpClient
//       .post(
//         "v2/downloadLink.php",
//         qs.stringify({
//           action: "getLink",
//           "source[appID]": aid,
//           "source[companyID]": cid,
//         })
//       )
//       .then((res) => {
//         if (res.data.success) {
//           this.setState({ 
//             androidQrData: res.data,
//             androidLoading: false 
//           });
          
//           if (isMobileOrTablet) {
//             // Android: Regular window.open (unchanged)
//             window.open(res.data.androidDownload, '_blank');
//           } else {
//             this.setState({ showAndroidQR: true });
//           }
//         } else {
//           this.setState({ 
//             androidError: res.data.message || "Failed to get download link",
//             androidLoading: false 
//           });
//         }
//       })
//       .catch((error) => {
//         console.error("Error fetching Android download link:", error);
//         this.setState({ 
//           androidError: "Network error. Please try again.",
//           androidLoading: false 
//         });
//       });
//   };

//   /* ---------- QR BUTTON HANDLERS ---------- */
//   handleOpenDownloadLink = () => {
//     if (this.state.qrData && this.state.qrData.download) {
//       const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
//       if (isIOS) {
//         this.safeNavigation(this.state.qrData.download);
//       } else {
//         window.open(this.state.qrData.download, '_blank');
//       }
//     }
//   };

//   handleOpenAndroidDownloadLink = () => {
//     if (this.state.androidQrData && this.state.androidQrData.androidDownload) {
//       window.open(this.state.androidQrData.androidDownload, '_blank');
//     }
//   };

//   render() {
//     const { showQR, showAndroidQR, qrData, androidQrData, loading, androidLoading, error, androidError } = this.state;
//     const isMobileOrTablet = window.matchMedia("(max-width: 1000px)").matches;

//     return (
//       <Container maxWidth={false} style={{ 
//         padding: '24px 16px', 
//         maxWidth: '100%',
//         minHeight: '100vh'
//       }}>
//         <Typography 
//           variant="h4" 
//           style={{ 
//             fontWeight: 600, 
//             marginBottom: 32,
//             color: '#333',
//             textAlign: 'center'
//           }}
//         >
//           Download Mobile Apps
//         </Typography>
        
//         <Grid container spacing={3} style={{ minHeight: 'calc(100vh - 120px)' }}>
//           {/* iOS Section - Left Side */}
//           <Grid item xs={12} md={6}>
//             <Paper 
//               elevation={3} 
//               style={{ 
//                 borderRadius: 12, 
//                 overflow: 'hidden',
//                 border: '1px solid #e0e0e0',
//                 backgroundColor: '#fff',
//                 height: '100%',
//                 padding: 0
//               }}
//             >
//               <Box style={{ padding: 32 }}>
//                 {/* iOS Header with App Store Icon */}
//                 <Box style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}>
//                   <i 
//                     className="zmdi zmdi-apple" 
//                     style={{ 
//                       fontSize: '36px',
//                       color: '#000',
//                       marginRight: 16
//                     }} 
//                   />
//                   <Box style={{ flex: 1 }}>
//                     <Box style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
//                       <Box style={{ flex: 1 }}>
//                         <Typography 
//                           variant="h5" 
//                           style={{ 
//                             fontWeight: 600,
//                             color: '#333',
//                             lineHeight: 1.2,
//                             marginBottom: 4
//                           }}
//                         >
//                           Download App for Apple/iOS
//                         </Typography>
//                         <Typography 
//                           variant="body1" 
//                           style={{ 
//                             color: '#666',
//                             lineHeight: 1.4
//                           }}
//                         >
//                           Get the app on your iPhone or iPad
//                         </Typography>
//                       </Box>
//                       <Box style={{ 
//                         marginLeft: 16,
//                         display: 'flex',
//                         alignItems: 'flex-start'
//                       }}>
//                         <img 
//                           src="/images/app_store.png" 
//                           alt="App Store"
//                           style={{ 
//                             width: 42, 
//                             height: 42,
//                             objectFit: 'contain'
//                           }}
//                         />
//                       </Box>
//                     </Box>
//                   </Box>
//                 </Box>

//                 {/* Installation Guide - iOS */}
//                 <Box style={{ marginBottom: 32 }}>
//                   <Typography 
//                     variant="h6" 
//                     style={{ 
//                       fontWeight: 600,
//                       marginBottom: 16,
//                       color: '#333',
//                       borderBottom: '1px solid #f0f0f0',
//                       paddingBottom: 8
//                     }}
//                   >
//                     Installation Guide
//                   </Typography>
//                   <Grid container spacing={2}>
//                     {[
//                       { step: 1, desc: "Click the Download button below" },
//                       !isMobileOrTablet && { step: 2, desc: "Scan the QR code generated" },
//                       { step: isMobileOrTablet ? 2 : 3, desc: "Redeem the installation code" },
//                       { step: isMobileOrTablet ? 3 : 4, desc: "Follow installation prompts" },
//                       { step: isMobileOrTablet ? 4 : 5, desc: "Trust developer in Settings (if prompted)" }
//                     ]
//                     .filter(step => step)
//                     .map((item) => (
//                       <Grid item xs={12} sm={6} key={item.step}>
//                         <Box style={{ 
//                           display: 'flex', 
//                           alignItems: 'flex-start',
//                           backgroundColor: '#f9f9f9',
//                           padding: 12,
//                           borderRadius: 6,
//                           marginBottom: 8,
//                           height: '100%'
//                         }}>
//                           <Box style={{ 
//                             width: 24, 
//                             height: 24, 
//                             borderRadius: '50%', 
//                             backgroundColor: '#000',
//                             color: '#fff',
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             marginRight: 12,
//                             flexShrink: 0,
//                             fontSize: '0.875rem',
//                             fontWeight: 600
//                           }}>
//                             {item.step}
//                           </Box>
//                           <Typography variant="body2" style={{ color: '#666' }}>
//                             {item.desc}
//                           </Typography>
//                         </Box>
//                       </Grid>
//                     ))}
//                   </Grid>
//                 </Box>

//                 {/* QR Code Section - iOS */}
//                 {showQR && qrData && (
//                   <Box style={{ 
//                     display: 'flex', 
//                     flexDirection: 'column', 
//                     alignItems: 'center',
//                     marginBottom: 32,
//                     padding: '20px 0'
//                   }}>
//                     <Box style={{ 
//                       width: 220, 
//                       height: 220, 
//                       borderRadius: 12,
//                       backgroundColor: '#fff',
//                       border: '2px solid #e0e0e0',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       marginBottom: 24,
//                       padding: 16,
//                       boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
//                     }}>
//                       {qrData.qrcode && (
//                         <img 
//                           src={qrData.qrcode} 
//                           alt="QR Code" 
//                           style={{ 
//                             width: '100%', 
//                             height: '100%',
//                             objectFit: 'contain'
//                           }}
//                         />
//                       )}
//                     </Box>
                    
//                     <Typography 
//                       variant="body1" 
//                       style={{ 
//                         fontWeight: 500,
//                         marginBottom: 16,
//                         color: '#333',
//                         textAlign: 'center'
//                       }}
//                     >
//                       Scan QR code with your phone camera to download
//                     </Typography>
//                   </Box>
//                 )}

//                 {/* Download Button - iOS */}
//                 <Box style={{ 
//                   display: 'flex', 
//                   flexDirection: 'column', 
//                   alignItems: 'center',
//                   marginBottom: 32,
//                   padding: '20px 0'
//                 }}>
//                   {loading && (
//                     <Box style={{ 
//                       display: 'flex', 
//                       alignItems: 'center', 
//                       justifyContent: 'center',
//                       marginBottom: 16
//                     }}>
//                       <div className="zmdi zmdi-spinner zmdi-hc-spin" style={{ fontSize: '24px', color: '#666', marginRight: 12 }} />
//                       <Typography variant="body1" color="textSecondary">
//                         Loading...
//                       </Typography>
//                     </Box>
//                   )}
                  
//                   {error && (
//                     <Box style={{ 
//                       backgroundColor: '#ffebee', 
//                       padding: 16, 
//                       borderRadius: 8,
//                       marginBottom: 16,
//                       width: '100%',
//                       textAlign: 'center'
//                     }}>
//                       <Typography variant="body1" color="error">
//                         {error}
//                       </Typography>
//                     </Box>
//                   )}
                  
//                   <Button
//                     variant="contained"
//                     onClick={() => this.handleDownloadClick('ios')}
//                     disabled={loading}
//                     style={{
//                       padding: '14px 40px',
//                       borderRadius: 8,
//                       backgroundColor: '#000',
//                       color: '#fff',
//                       textTransform: 'none',
//                       fontWeight: 600,
//                       fontSize: '1rem',
//                       minWidth: 240,
//                       height: 56
//                     }}
//                   >
//                     <i 
//                       className="zmdi zmdi-apple" 
//                       style={{ 
//                         fontSize: '24px',
//                         marginRight: 12
//                       }} 
//                     />
//                     Download Apple/iOS App
//                   </Button>
//                 </Box>

//                 {/* System Requirements - iOS */}
//                 <Box style={{ marginBottom: 24 }}>
//                   <Typography 
//                     variant="h6" 
//                     style={{ 
//                       fontWeight: 600,
//                       marginBottom: 16,
//                       color: '#333',
//                       borderBottom: '1px solid #f0f0f0',
//                       paddingBottom: 8
//                     }}
//                   >
//                     System Requirements
//                   </Typography>
//                   <Grid container spacing={2}>
//                     <Grid item xs={6}>
//                       <Typography variant="body2" style={{ color: '#666', marginBottom: 8 }}>
//                         <Box component="span" style={{ fontWeight: 600 }}>OS Version:</Box> iOS 14+
//                       </Typography>
//                     </Grid>
//                     <Grid item xs={6}>
//                       <Typography variant="body2" style={{ color: '#666', marginBottom: 8 }}>
//                         <Box component="span" style={{ fontWeight: 600 }}>File Size:</Box> 45 MB
//                       </Typography>
//                     </Grid>
//                     <Grid item xs={6}>
//                       <Typography variant="body2" style={{ color: '#666', marginBottom: 8 }}>
//                         <Box component="span" style={{ fontWeight: 600 }}>Storage:</Box> 150 MB
//                       </Typography>
//                     </Grid>
//                   </Grid>
//                 </Box>

//                 {/* How to Check Device Specifications - iOS */}
//                 <Box style={{ marginBottom: 24 }}>
//                   <Typography 
//                     variant="h6" 
//                     style={{ 
//                       fontWeight: 600,
//                       marginBottom: 16,
//                       color: '#333',
//                       borderBottom: '1px solid #f0f0f0',
//                       paddingBottom: 8
//                     }}
//                   >
//                     How to Check Your Device Specifications
//                   </Typography>
//                   <Grid container spacing={2}>
//                     {[
//                       { step: 1, title: "Go to Settings", desc: "Open Settings app on your iPhone/iPad" },
//                       { step: 2, title: "Select General", desc: "Tap on 'General' in the Settings menu" },
//                       { step: 3, title: "Tap About", desc: "Select 'About' to see device information" },
//                       { step: 4, title: "Check Details", desc: "Check iOS version and storage" }
//                     ].map((item) => (
//                       <Grid item xs={12} sm={6} key={item.step}>
//                         <Box style={{ 
//                           display: 'flex', 
//                           alignItems: 'flex-start',
//                           backgroundColor: '#f9f9f9',
//                           padding: 12,
//                           borderRadius: 6,
//                           marginBottom: 8,
//                           height: '100%'
//                         }}>
//                           <Box style={{ 
//                             width: 24, 
//                             height: 24, 
//                             borderRadius: '50%', 
//                             backgroundColor: '#000',
//                             color: '#fff',
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             marginRight: 12,
//                             flexShrink: 0,
//                             fontSize: '0.875rem',
//                             fontWeight: 600
//                           }}>
//                             {item.step}
//                           </Box>
//                           <Box>
//                             <Typography variant="body2" style={{ fontWeight: 600, color: '#333', marginBottom: 2 }}>
//                               {item.title}
//                             </Typography>
//                             <Typography variant="caption" style={{ color: '#666' }}>
//                               {item.desc}
//                             </Typography>
//                           </Box>
//                         </Box>
//                       </Grid>
//                     ))}
//                   </Grid>
//                 </Box>
//               </Box>
//             </Paper>
//           </Grid>

//           {/* Android Section - Right Side */}
//           <Grid item xs={12} md={6} style={{ position: 'relative' }}>
//             <Paper 
//               elevation={3} 
//               style={{ 
//                 borderRadius: 12, 
//                 overflow: 'hidden',
//                 border: '1px solid #e0e0f0',
//                 backgroundColor: '#fff',
//                 height: '100%',
//                 padding: 0
//               }}
//             >
//               <Box style={{ padding: 32 }}>
//                 {/* Android Header */}
//                 <Box style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}>
//                   <i 
//                     className="zmdi zmdi-android" 
//                     style={{ 
//                       fontSize: '36px',
//                       color: '#3DDC84',
//                       marginRight: 16
//                     }} 
//                   />
//                   <Box style={{ flex: 1 }}>
//                     <Box style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
//                       <Box style={{ flex: 1 }}>
//                         <Typography 
//                           variant="h5" 
//                           style={{ 
//                             fontWeight: 600,
//                             color: '#333',
//                             lineHeight: 1.2,
//                             marginBottom: 4
//                           }}
//                         >
//                           Download App for Samsung/Android
//                         </Typography>
//                         <Typography 
//                           variant="body1" 
//                           style={{ 
//                             color: '#666',
//                             lineHeight: 1.4
//                           }}
//                         >
//                           Get the app on your android device
//                         </Typography>
//                       </Box>
//                       <Box style={{ 
//                         marginLeft: 16,
//                         display: 'flex',
//                         alignItems: 'flex-start'
//                       }}>
//                         <img 
//                           src="/images/google-play.png" 
//                           alt="Google Play Store"
//                           style={{ 
//                             width: 42, 
//                             height: 42,
//                             objectFit: 'contain'
//                           }}
//                         />
//                       </Box>
//                     </Box>
//                   </Box>
//                 </Box>

//                 {/* Installation Guide - Android */}
//                 <Box style={{ marginBottom: 32 }}>
//                   <Typography 
//                     variant="h6" 
//                     style={{ 
//                       fontWeight: 600,
//                       marginBottom: 16,
//                       color: '#333',
//                       borderBottom: '1px solid #f0f0f0',
//                       paddingBottom: 8
//                     }}
//                   >
//                     Installation Guide
//                   </Typography>
//                   <Grid container spacing={2}>
//                     {[
//                       { step: 1, desc: "Click the Download button below" },
//                       !isMobileOrTablet && { step: 2, desc: "Scan the QR code generated" },
//                       { step: isMobileOrTablet ? 2 : 3, desc: "Tap 'Install' button" },
//                       { step: isMobileOrTablet ? 3 : 4, desc: "Follow installation prompts" },
//                       { step: isMobileOrTablet ? 4 : 5, desc: "Accept permissions (if prompted)" }
//                     ]
//                     .filter(step => step)
//                     .map((item) => (
//                       <Grid item xs={12} sm={6} key={item.step}>
//                         <Box style={{ 
//                           display: 'flex', 
//                           alignItems: 'flex-start',
//                           backgroundColor: '#f9f9f9',
//                           padding: 12,
//                           borderRadius: 6,
//                           marginBottom: 8,
//                           height: '100%'
//                         }}>
//                           <Box style={{ 
//                             width: 24, 
//                             height: 24, 
//                             borderRadius: '50%', 
//                             backgroundColor: '#3DDC84',
//                             color: '#fff',
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             marginRight: 12,
//                             flexShrink: 0,
//                             fontSize: '0.875rem',
//                             fontWeight: 600
//                           }}>
//                             {item.step}
//                           </Box>
//                           <Typography variant="body2" style={{ color: '#666' }}>
//                             {item.desc}
//                           </Typography>
//                         </Box>
//                       </Grid>
//                     ))}
//                   </Grid>
//                 </Box>

//                 {/* QR Code Section - Android */}
//                 {showAndroidQR && androidQrData && (
//                   <Box style={{ 
//                     display: 'flex', 
//                     flexDirection: 'column', 
//                     alignItems: 'center',
//                     marginBottom: 32,
//                     padding: '20px 0'
//                   }}>
//                     <Box style={{ 
//                       width: 220, 
//                       height: 220, 
//                       borderRadius: 12,
//                       backgroundColor: '#fff',
//                       border: '2px solid #e0e0e0',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       marginBottom: 24,
//                       padding: 16,
//                       boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
//                     }}>
//                       {androidQrData.androidQrcode && (
//                         <img 
//                           src={androidQrData.androidQrcode} 
//                           alt="Android QR Code" 
//                           style={{ 
//                             width: '100%', 
//                             height: '100%',
//                             objectFit: 'contain'
//                           }}
//                         />
//                       )}
//                     </Box>
                    
//                     <Typography 
//                       variant="body1" 
//                       style={{ 
//                         fontWeight: 500,
//                         marginBottom: 16,
//                         color: '#333',
//                         textAlign: 'center'
//                       }}
//                     >
//                       Scan QR code with your phone camera to download
//                     </Typography>
//                   </Box>
//                 )}

//                 {/* Android Download Button */}
//                 <Box style={{ 
//                   display: 'flex', 
//                   flexDirection: 'column', 
//                   alignItems: 'center',
//                   marginBottom: 32,
//                   padding: '20px 0'
//                 }}>
//                   {androidLoading && (
//                     <Box style={{ 
//                       display: 'flex', 
//                       alignItems: 'center', 
//                       justifyContent: 'center',
//                       marginBottom: 16
//                     }}>
//                       <div className="zmdi zmdi-spinner zmdi-hc-spin" style={{ fontSize: '24px', color: '#666', marginRight: 12 }} />
//                       <Typography variant="body1" color="textSecondary">
//                         Loading...
//                       </Typography>
//                     </Box>
//                   )}
                  
//                   {androidError && (
//                     <Box style={{ 
//                       backgroundColor: '#ffebee', 
//                       padding: 16, 
//                       borderRadius: 8,
//                       marginBottom: 16,
//                       width: '100%',
//                       textAlign: 'center'
//                     }}>
//                       <Typography variant="body1" color="error">
//                         {androidError}
//                       </Typography>
//                     </Box>
//                   )}
                  
//                   <Button
//                     variant="contained"
//                     onClick={() => this.handleDownloadClick('android')}
//                     disabled={androidLoading}
//                     style={{
//                       padding: '14px 24px',
//                       borderRadius: 8,
//                       backgroundColor: '#3DDC84',
//                       color: '#000',
//                       textTransform: 'none',
//                       fontWeight: 600,
//                       fontSize: '1rem',
//                       minWidth: {
//                         xs: '100%',
//                         sm: 280,
//                         md: 280
//                       },
//                       maxWidth: '100%',
//                       height: 56,
//                       whiteSpace: 'normal',
//                       lineHeight: 1.2,
//                       textAlign: 'center'
//                     }}
//                   >
//                     <i 
//                       className="zmdi zmdi-android" 
//                       style={{ 
//                         fontSize: '24px',
//                         marginRight: 8,
//                         flexShrink: 0
//                       }} 
//                     />
//                     <Box component="span" style={{ 
//                       display: 'inline-block',
//                       wordBreak: 'break-word'
//                     }}>
//                       Download Samsung/Android App
//                     </Box>
//                   </Button>
//                 </Box>

//                 {/* System Requirements - Android */}
//                 <Box style={{ marginBottom: 24 }}>
//                   <Typography 
//                     variant="h6" 
//                     style={{ 
//                       fontWeight: 600,
//                       marginBottom: 16,
//                       color: '#333',
//                       borderBottom: '1px solid #f0f0f0',
//                       paddingBottom: 8
//                     }}
//                   >
//                     System Requirements
//                   </Typography>
//                   <Grid container spacing={2}>
//                     <Grid item xs={6}>
//                       <Typography variant="body2" style={{ color: '#666', marginBottom: 8 }}>
//                         <Box component="span" style={{ fontWeight: 600 }}>OS Version:</Box> Android 7.0+
//                       </Typography>
//                     </Grid>
//                     <Grid item xs={6}>
//                       <Typography variant="body2" style={{ color: '#666', marginBottom: 8 }}>
//                         <Box component="span" style={{ fontWeight: 600 }}>File Size:</Box>~ 35 MB
//                       </Typography>
//                     </Grid>
//                     <Grid item xs={6}>
//                       <Typography variant="body2" style={{ color: '#666', marginBottom: 8 }}>
//                         <Box component="span" style={{ fontWeight: 600 }}>RAM:</Box> 2 GB minimum
//                       </Typography>
//                     </Grid>
//                     <Grid item xs={6}>
//                       <Typography variant="body2" style={{ color: '#666', marginBottom: 8 }}>
//                         <Box component="span" style={{ fontWeight: 600 }}>Storage:</Box> 150 MB
//                       </Typography>
//                     </Grid>
//                   </Grid>
//                 </Box>

//                 {/* How to Check Device Specifications - Android */}
//                 <Box style={{ marginBottom: 24 }}>
//                   <Typography 
//                     variant="h6" 
//                     style={{ 
//                       fontWeight: 600,
//                       marginBottom: 16,
//                       color: '#333',
//                       borderBottom: '1px solid #f0f0f0',
//                       paddingBottom: 8
//                     }}
//                   >
//                     How to Check Your Device Specifications
//                   </Typography>
//                   <Grid container spacing={2}>
//                     {[
//                       { step: 1, title: "Go to Settings", desc: "Open Settings app on your Android device" },
//                       { step: 2, title: "Select About Phone", desc: "Scroll down and tap 'About Phone'" },
//                       { step: 3, title: "Check Details", desc: "View Android version, RAM, and storage" },
//                     ].map((item) => (
//                       <Grid item xs={12} sm={6} key={item.step}>
//                         <Box style={{ 
//                           display: 'flex', 
//                           alignItems: 'flex-start',
//                           backgroundColor: '#f9f9f9',
//                           padding: 12,
//                           borderRadius: 6,
//                           marginBottom: 8,
//                           height: '100%'
//                         }}>
//                           <Box style={{ 
//                             width: 24, 
//                             height: 24, 
//                             borderRadius: '50%', 
//                             backgroundColor: '#3DDC84',
//                             color: '#fff',
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             marginRight: 12,
//                             flexShrink: 0,
//                             fontSize: '0.875rem',
//                             fontWeight: 600
//                           }}>
//                             {item.step}
//                           </Box>
//                           <Box>
//                             <Typography variant="body2" style={{ fontWeight: 600, color: '#333', marginBottom: 2 }}>
//                               {item.title}
//                             </Typography>
//                             <Typography variant="caption" style={{ color: '#666' }}>
//                               {item.desc}
//                             </Typography>
//                           </Box>
//                         </Box>
//                       </Grid>
//                     ))}
//                   </Grid>
//                 </Box>
//               </Box>
//             </Paper>
//           </Grid>
//         </Grid>
//       </Container>
//     );
//   }
// }

// export default DownloadApps;

// ****************************************************************************************

import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import Hidden from "@material-ui/core/Hidden";
import { httpClient } from "../../../appUtility/Api";
import qs from "qs";

class DownloadApps extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showQR: false,
      showAndroidQR: false,
      selectedPlatform: null,
      qrData: null,
      androidQrData: null,
      loading: false,
      androidLoading: false,
      error: null,
      androidError: null
    };
  }

  /* ---------- SAFE NAVIGATION (ONLY FOR IOS SAFARI) ---------- */
  safeNavigation = (url, existingTab) => {
    if (existingTab && !existingTab.closed) {
      existingTab.location.href = url;
      return;
    }

    var tab = window.open("", "_blank");

    if (tab) {
      tab.location.href = url;
    } else {
      window.location.href = url;
    }
  };

  /* ---------- IOS DOWNLOAD (WITH SAFARI FIX) ---------- */
  handleDownloadClick = (platform) => {
    if (platform === 'android') {
      this.handleAndroidDownloadClick();
      return;
    }

    const loginOBJ = JSON.parse(localStorage.getItem("login"));
    const { aid, cid } = loginOBJ;

    // Check screen size - tablet/mobile threshold at 1030px
    const isMobileOrTablet = window.matchMedia("(max-width: 1030px)").matches;
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    // Only pre-open tab for iOS devices that are below 1030px
    var tab = (isMobileOrTablet && isIOS) ? window.open("", "_blank") : null;

    this.setState({ 
      loading: true,
      error: null
    });

    httpClient
      .post(
        "v2/downloadLink.php",
        qs.stringify({
          action: "getLink",
          "source[appID]": aid,
          "source[companyID]": cid,
        })
      )
      .then((res) => {
        if (res.data.success) {
          this.setState({ 
            qrData: res.data,
            selectedPlatform: platform,
            loading: false 
          });
          
          if (isMobileOrTablet) {
            if (isIOS) {
              // iOS (screen < 1030px): Use safe navigation with pre-opened tab
              this.safeNavigation(res.data.download, tab);
            } else {
              // Android mobile (screen < 1030px): Use regular window.open
              window.open(res.data.download, '_blank');
            }
          } else {
            // Screen > 1030px - Show QR code (safe from redirection issues)
            this.setState({ showQR: true });
          }
        } else {
          if (tab) tab.close();
          this.setState({ 
            error: res.data.message || "Failed to get download link",
            loading: false 
          });
        }
      })
      .catch((error) => {
        if (tab) tab.close();
        console.error("Error fetching download link:", error);
        this.setState({ 
          error: "Network error. Please try again.",
          loading: false 
        });
      });
  };

  /* ---------- ANDROID DOWNLOAD ---------- */
  handleAndroidDownloadClick = () => {
    const loginOBJ = JSON.parse(localStorage.getItem("login"));
    const { aid, cid } = loginOBJ;

    const isMobileOrTablet = window.matchMedia("(max-width: 1030px)").matches;

    this.setState({ 
      androidLoading: true,
      androidError: null
    });

    httpClient
      .post(
        "v2/downloadLink.php",
        qs.stringify({
          action: "getLink",
          "source[appID]": aid,
          "source[companyID]": cid,
        })
      )
      .then((res) => {
        if (res.data.success) {
          this.setState({ 
            androidQrData: res.data,
            androidLoading: false 
          });
          
          if (isMobileOrTablet) {
            // Android mobile (screen < 1030px): Regular window.open
            window.open(res.data.androidDownload, '_blank');
          } else {
            // Screen > 1030px - Show QR code
            this.setState({ showAndroidQR: true });
          }
        } else {
          this.setState({ 
            androidError: res.data.message || "Failed to get download link",
            androidLoading: false 
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching Android download link:", error);
        this.setState({ 
          androidError: "Network error. Please try again.",
          androidLoading: false 
        });
      });
  };

  /* ---------- QR BUTTON HANDLERS ---------- */
  handleOpenDownloadLink = () => {
    if (this.state.qrData && this.state.qrData.download) {
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      const isMobileOrTablet = window.matchMedia("(max-width: 1030px)").matches;
      
      if (isMobileOrTablet && isIOS) {
        this.safeNavigation(this.state.qrData.download);
      } else {
        window.open(this.state.qrData.download, '_blank');
      }
    }
  };

  handleOpenAndroidDownloadLink = () => {
    if (this.state.androidQrData && this.state.androidQrData.androidDownload) {
      window.open(this.state.androidQrData.androidDownload, '_blank');
    }
  };

  render() {
    const { showQR, showAndroidQR, qrData, androidQrData, loading, androidLoading, error, androidError } = this.state;
    const isMobileOrTablet = window.matchMedia("(max-width: 1030px)").matches;

    return (
      <Container maxWidth={false} style={{ 
        padding: '24px 16px', 
        maxWidth: '100%',
        minHeight: '100vh'
      }}>
        <Typography 
          variant="h4" 
          style={{ 
            fontWeight: 600, 
            marginBottom: 32,
            color: '#333',
            textAlign: 'center'
          }}
        >
          Download Mobile Apps
        </Typography>
        
        <Grid container spacing={3} style={{ minHeight: 'calc(100vh - 120px)' }}>
          {/* iOS Section - Left Side */}
          <Grid item xs={12} md={6}>
            <Paper 
              elevation={3} 
              style={{ 
                borderRadius: 12, 
                overflow: 'hidden',
                border: '1px solid #e0e0e0',
                backgroundColor: '#fff',
                height: '100%',
                padding: 0
              }}
            >
              <Box style={{ padding: 32 }}>
                {/* iOS Header with App Store Icon */}
                <Box style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}>
                  <i 
                    className="zmdi zmdi-apple" 
                    style={{ 
                      fontSize: '36px',
                      color: '#000',
                      marginRight: 16
                    }} 
                  />
                  <Box style={{ flex: 1 }}>
                    <Box style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                      <Box style={{ flex: 1 }}>
                        <Typography 
                          variant="h5" 
                          style={{ 
                            fontWeight: 600,
                            color: '#333',
                            lineHeight: 1.2,
                            marginBottom: 4
                          }}
                        >
                          Download App for Apple/iOS
                        </Typography>
                        <Typography 
                          variant="body1" 
                          style={{ 
                            color: '#666',
                            lineHeight: 1.4
                          }}
                        >
                          Get the app on your iPhone or iPad
                        </Typography>
                      </Box>
                      <Box style={{ 
                        marginLeft: 16,
                        display: 'flex',
                        alignItems: 'flex-start'
                      }}>
                        <img 
                          src="/images/app_store.png" 
                          alt="App Store"
                          style={{ 
                            width: 42, 
                            height: 42,
                            objectFit: 'contain'
                          }}
                        />
                      </Box>
                    </Box>
                  </Box>
                </Box>

                {/* Installation Guide - iOS */}
                <Box style={{ marginBottom: 32 }}>
                  <Typography 
                    variant="h6" 
                    style={{ 
                      fontWeight: 600,
                      marginBottom: 16,
                      color: '#333',
                      borderBottom: '1px solid #f0f0f0',
                      paddingBottom: 8
                    }}
                  >
                    Installation Guide
                  </Typography>
                  <Grid container spacing={2}>
                    {[
                      { step: 1, desc: "Click the Download button below" },
                      !isMobileOrTablet && { step: 2, desc: "Scan the QR code generated" },
                      { step: isMobileOrTablet ? 2 : 3, desc: "Redeem the installation code" },
                      { step: isMobileOrTablet ? 3 : 4, desc: "Follow installation prompts" },
                      { step: isMobileOrTablet ? 4 : 5, desc: "Trust developer in Settings (if prompted)" }
                    ]
                    .filter(step => step)
                    .map((item) => (
                      <Grid item xs={12} sm={6} key={item.step}>
                        <Box style={{ 
                          display: 'flex', 
                          alignItems: 'flex-start',
                          backgroundColor: '#f9f9f9',
                          padding: 12,
                          borderRadius: 6,
                          marginBottom: 8,
                          height: '100%'
                        }}>
                          <Box style={{ 
                            width: 24, 
                            height: 24, 
                            borderRadius: '50%', 
                            backgroundColor: '#000',
                            color: '#fff',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginRight: 12,
                            flexShrink: 0,
                            fontSize: '0.875rem',
                            fontWeight: 600
                          }}>
                            {item.step}
                          </Box>
                          <Typography variant="body2" style={{ color: '#666' }}>
                            {item.desc}
                          </Typography>
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                </Box>

                {/* QR Code Section - iOS */}
                {showQR && qrData && (
                  <Box style={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    alignItems: 'center',
                    marginBottom: 32,
                    padding: '20px 0'
                  }}>
                    <Box style={{ 
                      width: 220, 
                      height: 220, 
                      borderRadius: 12,
                      backgroundColor: '#fff',
                      border: '2px solid #e0e0e0',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginBottom: 24,
                      padding: 16,
                      boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                    }}>
                      {qrData.qrcode && (
                        <img 
                          src={qrData.qrcode} 
                          alt="QR Code" 
                          style={{ 
                            width: '100%', 
                            height: '100%',
                            objectFit: 'contain'
                          }}
                        />
                      )}
                    </Box>
                    
                    <Typography 
                      variant="body1" 
                      style={{ 
                        fontWeight: 500,
                        marginBottom: 16,
                        color: '#333',
                        textAlign: 'center'
                      }}
                    >
                      Scan QR code with your phone camera to download
                    </Typography>
                  </Box>
                )}

                {/* Download Button - iOS */}
                <Box style={{ 
                  display: 'flex', 
                  flexDirection: 'column', 
                  alignItems: 'center',
                  marginBottom: 32,
                  padding: '20px 0'
                }}>
                  {loading && (
                    <Box style={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      justifyContent: 'center',
                      marginBottom: 16
                    }}>
                      <div className="zmdi zmdi-spinner zmdi-hc-spin" style={{ fontSize: '24px', color: '#666', marginRight: 12 }} />
                      <Typography variant="body1" color="textSecondary">
                        Loading...
                      </Typography>
                    </Box>
                  )}
                  
                  {error && (
                    <Box style={{ 
                      backgroundColor: '#ffebee', 
                      padding: 16, 
                      borderRadius: 8,
                      marginBottom: 16,
                      width: '100%',
                      textAlign: 'center'
                    }}>
                      <Typography variant="body1" color="error">
                        {error}
                      </Typography>
                    </Box>
                  )}
                  
                  <Button
                    variant="contained"
                    onClick={() => this.handleDownloadClick('ios')}
                    disabled={loading}
                    style={{
                      padding: '14px 40px',
                      borderRadius: 8,
                      backgroundColor: '#000',
                      color: '#fff',
                      textTransform: 'none',
                      fontWeight: 600,
                      fontSize: '1rem',
                      minWidth: 240,
                      height: 56
                    }}
                  >
                    <i 
                      className="zmdi zmdi-apple" 
                      style={{ 
                        fontSize: '24px',
                        marginRight: 12
                      }} 
                    />
                    Download Apple/iOS App
                  </Button>
                </Box>

                {/* System Requirements - iOS */}
                <Box style={{ marginBottom: 24 }}>
                  <Typography 
                    variant="h6" 
                    style={{ 
                      fontWeight: 600,
                      marginBottom: 16,
                      color: '#333',
                      borderBottom: '1px solid #f0f0f0',
                      paddingBottom: 8
                    }}
                  >
                    System Requirements
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Typography variant="body2" style={{ color: '#666', marginBottom: 8 }}>
                        <Box component="span" style={{ fontWeight: 600 }}>OS Version:</Box> iOS 14+
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2" style={{ color: '#666', marginBottom: 8 }}>
                        <Box component="span" style={{ fontWeight: 600 }}>File Size:</Box> 45 MB
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2" style={{ color: '#666', marginBottom: 8 }}>
                        <Box component="span" style={{ fontWeight: 600 }}>Storage:</Box> 150 MB
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>

                {/* How to Check Device Specifications - iOS */}
                <Box style={{ marginBottom: 24 }}>
                  <Typography 
                    variant="h6" 
                    style={{ 
                      fontWeight: 600,
                      marginBottom: 16,
                      color: '#333',
                      borderBottom: '1px solid #f0f0f0',
                      paddingBottom: 8
                    }}
                  >
                    How to Check Your Device Specifications
                  </Typography>
                  <Grid container spacing={2}>
                    {[
                      { step: 1, title: "Go to Settings", desc: "Open Settings app on your iPhone/iPad" },
                      { step: 2, title: "Select General", desc: "Tap on 'General' in the Settings menu" },
                      { step: 3, title: "Tap About", desc: "Select 'About' to see device information" },
                      { step: 4, title: "Check Details", desc: "Check iOS version and storage" }
                    ].map((item) => (
                      <Grid item xs={12} sm={6} key={item.step}>
                        <Box style={{ 
                          display: 'flex', 
                          alignItems: 'flex-start',
                          backgroundColor: '#f9f9f9',
                          padding: 12,
                          borderRadius: 6,
                          marginBottom: 8,
                          height: '100%'
                        }}>
                          <Box style={{ 
                            width: 24, 
                            height: 24, 
                            borderRadius: '50%', 
                            backgroundColor: '#000',
                            color: '#fff',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginRight: 12,
                            flexShrink: 0,
                            fontSize: '0.875rem',
                            fontWeight: 600
                          }}>
                            {item.step}
                          </Box>
                          <Box>
                            <Typography variant="body2" style={{ fontWeight: 600, color: '#333', marginBottom: 2 }}>
                              {item.title}
                            </Typography>
                            <Typography variant="caption" style={{ color: '#666' }}>
                              {item.desc}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              </Box>
            </Paper>
          </Grid>

          {/* Android Section - Right Side */}
          <Grid item xs={12} md={6} style={{ position: 'relative' }}>
            <Paper 
              elevation={3} 
              style={{ 
                borderRadius: 12, 
                overflow: 'hidden',
                border: '1px solid #e0e0f0',
                backgroundColor: '#fff',
                height: '100%',
                padding: 0
              }}
            >
              <Box style={{ padding: 32 }}>
                {/* Android Header */}
                <Box style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}>
                  <i 
                    className="zmdi zmdi-android" 
                    style={{ 
                      fontSize: '36px',
                      color: '#3DDC84',
                      marginRight: 16
                    }} 
                  />
                  <Box style={{ flex: 1 }}>
                    <Box style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                      <Box style={{ flex: 1 }}>
                        <Typography 
                          variant="h5" 
                          style={{ 
                            fontWeight: 600,
                            color: '#333',
                            lineHeight: 1.2,
                            marginBottom: 4
                          }}
                        >
                          Download App for Samsung/Android
                        </Typography>
                        <Typography 
                          variant="body1" 
                          style={{ 
                            color: '#666',
                            lineHeight: 1.4
                          }}
                        >
                          Get the app on your android device
                        </Typography>
                      </Box>
                      <Box style={{ 
                        marginLeft: 16,
                        display: 'flex',
                        alignItems: 'flex-start'
                      }}>
                        <img 
                          src="/images/google-play.png" 
                          alt="Google Play Store"
                          style={{ 
                            width: 42, 
                            height: 42,
                            objectFit: 'contain'
                          }}
                        />
                      </Box>
                    </Box>
                  </Box>
                </Box>

                {/* Installation Guide - Android */}
                <Box style={{ marginBottom: 32 }}>
                  <Typography 
                    variant="h6" 
                    style={{ 
                      fontWeight: 600,
                      marginBottom: 16,
                      color: '#333',
                      borderBottom: '1px solid #f0f0f0',
                      paddingBottom: 8
                    }}
                  >
                    Installation Guide
                  </Typography>
                  <Grid container spacing={2}>
                    {[
                      { step: 1, desc: "Click the Download button below" },
                      !isMobileOrTablet && { step: 2, desc: "Scan the QR code generated" },
                      { step: isMobileOrTablet ? 2 : 3, desc: "Tap 'Install' button" },
                      { step: isMobileOrTablet ? 3 : 4, desc: "Follow installation prompts" },
                      { step: isMobileOrTablet ? 4 : 5, desc: "Accept permissions (if prompted)" }
                    ]
                    .filter(step => step)
                    .map((item) => (
                      <Grid item xs={12} sm={6} key={item.step}>
                        <Box style={{ 
                          display: 'flex', 
                          alignItems: 'flex-start',
                          backgroundColor: '#f9f9f9',
                          padding: 12,
                          borderRadius: 6,
                          marginBottom: 8,
                          height: '100%'
                        }}>
                          <Box style={{ 
                            width: 24, 
                            height: 24, 
                            borderRadius: '50%', 
                            backgroundColor: '#3DDC84',
                            color: '#fff',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginRight: 12,
                            flexShrink: 0,
                            fontSize: '0.875rem',
                            fontWeight: 600
                          }}>
                            {item.step}
                          </Box>
                          <Typography variant="body2" style={{ color: '#666' }}>
                            {item.desc}
                          </Typography>
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                </Box>

                {/* QR Code Section - Android */}
                {showAndroidQR && androidQrData && (
                  <Box style={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    alignItems: 'center',
                    marginBottom: 32,
                    padding: '20px 0'
                  }}>
                    <Box style={{ 
                      width: 220, 
                      height: 220, 
                      borderRadius: 12,
                      backgroundColor: '#fff',
                      border: '2px solid #e0e0e0',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginBottom: 24,
                      padding: 16,
                      boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                    }}>
                      {androidQrData.androidQrcode && (
                        <img 
                          src={androidQrData.androidQrcode} 
                          alt="Android QR Code" 
                          style={{ 
                            width: '100%', 
                            height: '100%',
                            objectFit: 'contain'
                          }}
                        />
                      )}
                    </Box>
                    
                    <Typography 
                      variant="body1" 
                      style={{ 
                        fontWeight: 500,
                        marginBottom: 16,
                        color: '#333',
                        textAlign: 'center'
                      }}
                    >
                      Scan QR code with your phone camera to download
                    </Typography>
                  </Box>
                )}

                {/* Android Download Button */}
                <Box style={{ 
                  display: 'flex', 
                  flexDirection: 'column', 
                  alignItems: 'center',
                  marginBottom: 32,
                  padding: '20px 0'
                }}>
                  {androidLoading && (
                    <Box style={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      justifyContent: 'center',
                      marginBottom: 16
                    }}>
                      <div className="zmdi zmdi-spinner zmdi-hc-spin" style={{ fontSize: '24px', color: '#666', marginRight: 12 }} />
                      <Typography variant="body1" color="textSecondary">
                        Loading...
                      </Typography>
                    </Box>
                  )}
                  
                  {androidError && (
                    <Box style={{ 
                      backgroundColor: '#ffebee', 
                      padding: 16, 
                      borderRadius: 8,
                      marginBottom: 16,
                      width: '100%',
                      textAlign: 'center'
                    }}>
                      <Typography variant="body1" color="error">
                        {androidError}
                      </Typography>
                    </Box>
                  )}
                  
                  <Button
                    variant="contained"
                    onClick={() => this.handleDownloadClick('android')}
                    disabled={androidLoading}
                    style={{
                      padding: '14px 24px',
                      borderRadius: 8,
                      backgroundColor: '#3DDC84',
                      color: '#000',
                      textTransform: 'none',
                      fontWeight: 600,
                      fontSize: '1rem',
                      minWidth: {
                        xs: '100%',
                        sm: 280,
                        md: 280
                      },
                      maxWidth: '100%',
                      height: 56,
                      whiteSpace: 'normal',
                      lineHeight: 1.2,
                      textAlign: 'center'
                    }}
                  >
                    <i 
                      className="zmdi zmdi-android" 
                      style={{ 
                        fontSize: '24px',
                        marginRight: 8,
                        flexShrink: 0
                      }} 
                    />
                    <Box component="span" style={{ 
                      display: 'inline-block',
                      wordBreak: 'break-word'
                    }}>
                      Download Samsung/Android App
                    </Box>
                  </Button>
                </Box>

                {/* System Requirements - Android */}
                <Box style={{ marginBottom: 24 }}>
                  <Typography 
                    variant="h6" 
                    style={{ 
                      fontWeight: 600,
                      marginBottom: 16,
                      color: '#333',
                      borderBottom: '1px solid #f0f0f0',
                      paddingBottom: 8
                    }}
                  >
                    System Requirements
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Typography variant="body2" style={{ color: '#666', marginBottom: 8 }}>
                        <Box component="span" style={{ fontWeight: 600 }}>OS Version:</Box> Android 7.0+
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2" style={{ color: '#666', marginBottom: 8 }}>
                        <Box component="span" style={{ fontWeight: 600 }}>File Size:</Box>~ 35 MB
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2" style={{ color: '#666', marginBottom: 8 }}>
                        <Box component="span" style={{ fontWeight: 600 }}>RAM:</Box> 2 GB minimum
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2" style={{ color: '#666', marginBottom: 8 }}>
                        <Box component="span" style={{ fontWeight: 600 }}>Storage:</Box> 150 MB
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>

                {/* How to Check Device Specifications - Android */}
                <Box style={{ marginBottom: 24 }}>
                  <Typography 
                    variant="h6" 
                    style={{ 
                      fontWeight: 600,
                      marginBottom: 16,
                      color: '#333',
                      borderBottom: '1px solid #f0f0f0',
                      paddingBottom: 8
                    }}
                  >
                    How to Check Your Device Specifications
                  </Typography>
                  <Grid container spacing={2}>
                    {[
                      { step: 1, title: "Go to Settings", desc: "Open Settings app on your Android device" },
                      { step: 2, title: "Select About Phone", desc: "Scroll down and tap 'About Phone'" },
                      { step: 3, title: "Check Details", desc: "View Android version, RAM, and storage" },
                    ].map((item) => (
                      <Grid item xs={12} sm={6} key={item.step}>
                        <Box style={{ 
                          display: 'flex', 
                          alignItems: 'flex-start',
                          backgroundColor: '#f9f9f9',
                          padding: 12,
                          borderRadius: 6,
                          marginBottom: 8,
                          height: '100%'
                        }}>
                          <Box style={{ 
                            width: 24, 
                            height: 24, 
                            borderRadius: '50%', 
                            backgroundColor: '#3DDC84',
                            color: '#fff',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginRight: 12,
                            flexShrink: 0,
                            fontSize: '0.875rem',
                            fontWeight: 600
                          }}>
                            {item.step}
                          </Box>
                          <Box>
                            <Typography variant="body2" style={{ fontWeight: 600, color: '#333', marginBottom: 2 }}>
                              {item.title}
                            </Typography>
                            <Typography variant="caption" style={{ color: '#666' }}>
                              {item.desc}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    );
  }
}

export default DownloadApps;